import React from "react";
import {useEffect} from 'react';
import {useSelector,useDispatch} from 'react-redux';
import {Button} from '@material-ui/core';
import { Grid, TextField,CircularProgress,Typography,Divider, Card, CardContent} from "@material-ui/core";
import {useHistory} from 'react-router-dom';
import { useLocation } from "react-router-dom";
import * as userActions from '../actions/authenticationActions';
import * as briefActions from '../actions/briefActions';
import _ from 'lodash';

function LoginChooseSite(props){
  const dispatch = useDispatch();
  const history = useHistory();
  const loggedInState = useSelector(state => state.auth);
  const location = useLocation();
  const [isLoading, setIsLoading] = React.useState(false);

  useEffect(() => {
    if(isLoading){
      return;
    } else if(_.isEmpty(loggedInState.adthriveSites)){
      // fetch all sites
      setIsLoading(true);
      dispatch(userActions.fetchAdthriveSites(() => {
        setIsLoading(false);
      }));
    }
  });

  // automatically choose site if user only has one site
  useEffect(() => {
    let {adthriveSites} = loggedInState;
    if(adthriveSites && adthriveSites.length === 1){
      handleChooseSite(adthriveSites[0]);
    }
  }, [loggedInState]);

  const handleChooseSite = (site) => {
    dispatch(userActions.setActiveSite(site));
    history.push('/dashboard_adthrive');
    dispatch(briefActions.getAdthriveBriefs());
  }

  let {adthriveSites} = loggedInState;
  let isEmpty = _.isEmpty(adthriveSites);

  return(
      <Grid container xs="12" direction="column" spacing={1} >
        <Grid item>
          <Typography variant="h6" color="primary" style={{fontWeight:'bold',textAlign:'center', marginTop: '20px'}}>Choose A Site</Typography>
        </Grid>
        <Grid item style={{padding:'17px'}}>
          {isLoading && <div>loading sites...</div>}
          {!isLoading && isEmpty && <div>No AdThrive sites found</div>}
          {!isLoading && !isEmpty && _.map(adthriveSites, (site) => {
            return <Card style={{marginBottom:10,borderRadius:'0.3rem',cursor:'pointer'}} onClick={() => {handleChooseSite(site);}} >
                      <CardContent style={{paddingBottom: '13px', padding: '13px'}}>
                        {site.name}
                      </CardContent>
                    </Card>
          })}
        </Grid>
      </Grid>
  );

}

export default LoginChooseSite;